import { Outlet } from 'react-router-dom';
import { SiteFooter } from '../SiteFooter';
import { MobileStoreBottomNav } from './MobileStoreBottomNav';

/**
 * Public store shell: mobile bottom bar (home / library / profile) and outlet padding
 * so content is not covered by the fixed bar. Footer sits above the bottom nav.
 */
export function StorefrontLayout() {
  return (
    <div className="relative flex min-h-dvh w-full max-w-[100vw] flex-col">
      <div className="flex min-h-0 flex-1 flex-col pb-[calc(4.5rem+env(safe-area-inset-bottom))] md:pb-0">
        <div className="min-h-0 w-full min-w-0 flex-1">
          <Outlet />
        </div>
        <SiteFooter />
      </div>
      <MobileStoreBottomNav />
    </div>
  );
}
